import { query, mutation } from '@/dex-shared/helpers/graphql';

interface Material {
  id: number;
  materialId: number;
  name: string;
  position: number;
  type: string;
}

export default {
  state: {
    boards: [],
    board: {
      id: null,
      title: null,
      description: null,
      materials: [],
      isPreregistered: false,
      hasPostgradMicrocertificateEnabled: false,
      boardSectionsByBoardId: {
        nodes: [],
      },
    },
    // questions: []
  },
  getters: {
    currentBoard: (state: any) => {
      return state.board;
    },
    boardByBoardId: (state: any) => (boardId: number) => {
      return state.boards.filter((board: any) => {
        return board.id == boardId;
      })[0];
    },
  },
  mutations: {
    SET_BOARDS(state: any, boards: any) {
      state.boards = boards.map((board: any) => {
        let boardsClassrooms = board.boardsClassroomsByBoardId;
        if (boardsClassrooms && boardsClassrooms.nodes.length > 0) {
          board.classrooms = boardsClassrooms.nodes.map((board: any) => ({
            ...board.classroomByClassroomId,
            boardsClassroomId: board.id,
          }));
        }
        return board;
      });
    },

    SET_CURRENT_BOARD(state: any, board: any) {
      state.board = board;
      if (board.materialsByBoardId) {
        state.board.materials = board.materialsByBoardId.nodes.map(
          (material: any) => {
            if (material) {
              if (material.examByExamId) {
                material = {
                  ...material.examByExamId,
                  position: material.position,
                  materialId: material.id,
                };
                material.type = 'Exam';
              } else if (material.examGroupByExamGroupId) {
                material = {
                  ...material.examGroupByExamGroupId,
                  position: material.position,
                  materialId: material.id,
                };
                material.type = 'ExamGroup';
              } else if (material.listByListId) {
                material = {
                  ...material.listByListId,
                  position: material.position,
                  materialId: material.id,
                };
                material.type = 'List';
              } else if (material.questionByQuestionId) {
                material = {
                  ...material.questionByQuestionId,
                  position: material.position,
                  materialId: material.id,
                };
                material.type = 'Question';
              }
            }
            return material;
          },
        );
      } else {
        state.board.materials = [];
      }
      let boardsClassrooms = board.boardsClassroomsByBoardId;
      if (boardsClassrooms && boardsClassrooms.nodes.length > 0) {
        state.board.classrooms = boardsClassrooms.nodes.map((board: any) => ({
          ...board.classroomByClassroomId,
          boardsClassroomId: board.id,
        }));
      }
      let boardsTeachers = board.boardsTeachersByBoardId;
      if (boardsTeachers && boardsTeachers.nodes.length > 0) {
        state.board.teachers = boardsTeachers.nodes.map((board: any) => ({
          ...board.teacherByTeacherId,
          boardsTeacherId: board.id,
        }));
      }
    },

    SET_EMPTY_BOARD(state: any) {
      let board = {
        id: null,
        title: null,
        description: null,
        isPreregistered: false,
        hasPostgradMicrocertificateEnabled: false,
      };
      state.board = board;
    },

    UPDATE_MATERIAL_REORDERED(state: any, materials: Array<Material>) {
      state.board = { ...state.board, materials };
    },

    // REMOVE_LIST(state: any, index: number) {
    //   state.lists.splice(index, 1);
    // }
  },
  actions: {
    async PULL_BOARD({ commit }: any, boardId: number) {
      let response = await query(
        `query getBoardByIdDexAdmin($boardId: Int!) {
          boardById(id: $boardId) {
            id
            title
            description
            descomplicaDisciplineSlug
            studyCaseId
            isPreregistered
            hasPostgradMicrocertificateEnabled
            workload
            boardSectionsByBoardId {
              nodes {
                id
                title
                descomplicaSubjectSlug
              }
            }
            boardsTeachersByBoardId {
              nodes {
                id
                teacherByTeacherId {
                  id
                  name
                  avatarUrl
                  boardsTeachersByTeacherId {
                    nodes {
                      id
                    }
                  }
                }
              }
            }
            materialsByBoardId (orderBy: POSITION_ASC) {
              nodes {
                position
                id
                questionByQuestionId {
                  id
                  content
                }
                examByExamId {
                  id
                  name
                }
                examGroupByExamGroupId {
                  id
                  name
                }
                listByListId{
                  id
                  name
                }
              }
            }
            boardsClassroomsByBoardId{
              nodes {
                id
                classroomByClassroomId {
                  id
                  name
                  descomplicaCourseSlug
                  courseByCourseId {
                    id
                    name
                    descomplicaCategorySlug
                  }
                }
              }
            }
          }
        }`,
        {
          boardId: +boardId,
        },
      );

      let board = response.data.boardById;
      commit('SET_CURRENT_BOARD', board);
    },

    async PUSH_BOARD({ commit, rootState }: any, board: any) {
      let userId = rootState.auth.user ? rootState.auth.user.id : null;
      let response;
      let boardResponse;
      const commonParameters =
        '$title: String!, $description: String!, $isPreregistered: Boolean!, $hasPostgradMicrocertificateEnabled: Boolean!, $workload: Int';

      if (board.id != null) {
        response = await mutation(
          `mutation updateBoard (
            $boardId: Int!,
            ${commonParameters} ,
            $studyCaseId: Int,
            $descomplicaDisciplineSlug: String,
          ) {
            updateBoardById(
              input:
                {
                  id: $boardId,
                  boardPatch:
                  {
                    title: $title,
                    description: $description,
                    studyCaseId: $studyCaseId,
                    descomplicaDisciplineSlug: $descomplicaDisciplineSlug,
                    isPreregistered: $isPreregistered,
                    hasPostgradMicrocertificateEnabled: $hasPostgradMicrocertificateEnabled,
                    workload: $workload
                  }
                }
            )
            {
              board {
                id
                title
                description
                workload
                descomplicaDisciplineSlug
                studyCaseId,
                boardSectionsByBoardId {
                  nodes {
                    id
                    title
                    descomplicaSubjectSlug
                  }
                }
                materialsByBoardId {
                  nodes {
                    questionByQuestionId {
                      id
                      content
                    }
                    examByExamId {
                      id
                      name
                    }
                    examGroupByExamGroupId {
                      id
                      name
                    }
                    listByListId{
                      id
                      name
                    }
                  }
                }
                boardsClassroomsByBoardId{
                  nodes {
                    id
                    classroomByClassroomId {
                      id
                      name
                      descomplicaCourseSlug
                      courseByCourseId {
                        id
                        name
                        descomplicaCategorySlug
                      }
                    }
                  }
                }
              }
            }
          }`,
          {
            boardId: board.id,
            title: board.title,
            description: board.description,
            studyCaseId: parseInt(board.studyCaseId, 10),
            descomplicaDisciplineSlug: board.descomplicaDisciplineSlug,
            isPreregistered: board.isPreregistered,
            hasPostgradMicrocertificateEnabled:
              board.hasPostgradMicrocertificateEnabled,
            workload: +board.workload,
          },
        );
        boardResponse = response.data.updateBoardById.board;
      } else {
        //create
        response = await mutation(
          `mutation createBoard ($userId: Int!, ${commonParameters}) {
            createBoard(
              input:
                {
                  board:
                  {
                    userId: $userId,
                    title: $title,
                    description: $description,
                    isPreregistered: $isPreregistered,
                    hasPostgradMicrocertificateEnabled: $hasPostgradMicrocertificateEnabled
                    workload: $workload
                  }
                }
            )
            {
              board {
                id
                title
                description
                descomplicaDisciplineSlug
                isPreregistered
                hasPostgradMicrocertificateEnabled
                workload
                boardSectionsByBoardId {
                  nodes {
                    id
                    title
                    descomplicaSubjectSlug
                  }
                }
                materialsByBoardId {
                  nodes {
                    questionByQuestionId {
                      id
                      content
                    }
                    examByExamId {
                      id
                      name
                    }
                    examGroupByExamGroupId {
                      id
                      name
                    }
                    listByListId{
                      id
                      name
                    }
                  }
                }
                boardsClassroomsByBoardId{
                  nodes {
                    id
                    classroomByClassroomId {
                      id
                      name
                      descomplicaCourseSlug
                      courseByCourseId {
                        id
                        name
                        descomplicaCategorySlug
                      }
                    }
                  }
                }
              }
            }
          }`,
          {
            userId: userId,
            title: board.title,
            description: board.description,
            isPreregistered: board.isPreregistered,
            hasPostgradMicrocertificateEnabled:
              board.hasPostgradMicrocertificateEnabled,
            workload: +board.workload,
          },
        );
        boardResponse = response.data.createBoard.board;
      }

      if (boardResponse != null) {
        commit('SET_CURRENT_BOARD', boardResponse);
      }
    },

    async PULL_BOARDS({ commit }: any) {
      let response = await query(`query getAllBoardsDexAdmin{
        allBoards(orderBy: TITLE_ASC) {
          nodes {
            id
            title
            slug
            boardsClassroomsByBoardId{
              nodes {
                id
                classroomByClassroomId {
                  id
                  name
                  courseByCourseId {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }`);
      let boardsNodes = response.data.allBoards;
      if (boardsNodes) {
        commit('SET_BOARDS', boardsNodes.nodes);
      }
    },

    async ADD_MATERIAL({ rootState }: any, data: any) {
      // TODO: check sum(materials) = 1 && sum(aggregators) = 1
      let userId = rootState.auth.user ? rootState.auth.user.id : null;

      // materials
      let questionId = data.questionId || null;
      let examId = data.examId || null;
      let examGroupId = data.examGroupId || null;
      let listId = data.listId || null;
      let articleId = null;

      // aggregators
      let boardId = data.boardId || null;
      let boardSectionsId = data.boardSectionsId || null;
      let boardSubsectionsId = data.boardSubsectionsId || null;

      //material
      let materialResponse = await mutation(
        `mutation createMaterial($questionId: Int, $examId: Int, $examGroupId: Int,
           $listId: Int, $articleId: Int, $userId: Int!,
            $boardId: Int, $boardSectionsId: Int, $boardSubsectionsId: Int){
        createMaterial(
          input: {
            material: {
              userId: $userId,
              questionId: $questionId,
              examId: $examId,
              examGroupId: $examGroupId,
              listId: $listId,
              articleId: $articleId,
              boardId: $boardId,
              boardSectionsId: $boardSectionsId,
              boardSubsectionsId: $boardSubsectionsId
            }
          }
        ) {
          material {
            id
          }
        }
      }`,
        {
          userId,
          questionId,
          examId,
          examGroupId,
          listId,
          articleId,
          boardId,
          boardSectionsId,
          boardSubsectionsId,
        },
      );
      materialResponse.data.createMaterial.material.id;
      //TODO success/error message
    },

    async REMOVE_MATERIAL(_: any, materialId: number) {
      await mutation(
        `mutation deleteMaterial($materialId: Int!){
        deleteMaterialById(input: {
          id: $materialId
        }) {
          material {
            id
          }
        }
      }`,
        {
          materialId,
        },
      );

      //TODO success/error message
    },

    async REVOME_BOARDS_CLASSROOM(_: any, boardsClassroomId: number) {
      return mutation(
        `
          mutation deleteBoardsClassroom($boardsClassroomId: Int!) {
            deleteBoardsClassroomById(input: {
              id: $boardsClassroomId
            }) {
              boardsClassroom {
                id
              }
            }
          }
        `,
        {
          boardsClassroomId,
        },
      );
    },
    async UPDATE_MATERIAL_POSITION(_: any, materials: Array<Material>) {
      await resetAllMaterialPositions(materials);

      materials.map(async (material, index) => {
        await updateMaterialPosition(material.materialId, index);
      });
    },
  },
};

const resetAllMaterialPositions = async materials => {
  for (const material of materials)
    await updateMaterialPosition(material.materialId, null);
};

const updateMaterialPosition = async (id: number, position: number) => {
  const updateMaterialPositionQuery = `mutation UpdateMaterialPosition($id: Int!, $position: Int){
    updateMaterialById(
      input: {
        id: $id
        materialPatch: {
          position: $position
        }
      }
    ) {
      material {
        id
      }
    }
  }`;
  return mutation(updateMaterialPositionQuery, {
    id,
    position,
  });
};
